
    import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
    import { Content, ModalController, NavParams } from 'ionic-angular';
    import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
    import { RolresponsaveisService } from '../../../../providers/rolresponsaveis-service';

    import { MenuService } from '../../../../providers/menu-service';
    import { AlertService } from '../../../../providers/alert-service';
    import { ModulosController } from '../../modulos-controller';
    import { UsuarioService } from '../../../../providers/usuario-service';
    import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
    import { ModalDetalhesRolResponsaveisPage } from '../../../modais/modal-detalhes-rol-responsaveis/modal-detalhes-rol-responsaveis';
    import { ModalPortariasPage } from '../../../modais/modal-portarias/modal-portarias';

    import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
    import { IMyDateRange, IMyDateRangeModel, IMyDrpOptions } from 'mydaterangepicker';
    
    import { ContratoService } from "../../../../providers/contrato-service";

    import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

    declare var require: any;
    declare var jsPDF: any;

    @Component({
        selector: 'page-rol-responsaveis',
        templateUrl: 'rol-responsaveis.html',
        providers: [
            ContratosGestaoService
        ]
    })

    export class RolResponsaveisCGPage extends ModulosController {
        @ViewChild(Content) content: Content;
        // Lista Construtora da Página
        cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
        cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
        dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
        phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
        emailMask = [/\^[A-Za-z0-9._%+-]\+/, '@', /[A-Za-z0-9.-]\+/, '.', /[A-Za-z]\{2,4}\$/];
        rolDeResponsaveis: any;
        usuario: any;
        isCGE: boolean = false;
        PCAAtiva: any;
        shownGroup: any = [];
        shownGroupAtos: any = [];
        shownGroupTelefones: any = [];
        loading: boolean = true;
        loadingContratos: boolean = true;
        buscandoCEPFuncional: boolean = false;
        buscandoCEPPessoal: boolean = false;
        telaListagem: boolean = true;
        telaCriacao: boolean = false;
        edicaoResponsavel: boolean = false;
        criacaoResponsavel: boolean = false;
        visualizacaoResponsavel: boolean = false;
        listaEstados: any = [];
        listaCidadesEnderecoPessoal: any = [];
        listaCidadesEnderecoFuncional: any = [];
        listaTiposTelefone: any = [];
        listaCargos: any = [];
        listaAtos: any = [];
        selectedContrato: any;
        listaGrupos: any = [];
        cpfPreenchido: boolean = false;
        cpfCarregado: boolean = true;
        cpfInvalido: boolean = false;
        listaContratos: any = [];
        funcaoSelecionada: boolean = false;
        telefonesParaRemover: any = [];
        periodosParaRemover: any = [];
        pessoaGrupoAtual: any = {
            "contrato": {
                "id": 0,
                "nmContrato": "",
            },
            "idPessoaGrupo": 0,
            // "dsDescricaoCargo": "",
            "idGrupo": 0,
            "subGrupo": {
                "idSubgrupo": "",
                "dsSubgrupo": ""
            },
            "listaPeriodoFuncao": [
                // ],
                // "listaPortarias": [
            ]
        };
        pessoaAtual: any = {
            "idPessoa": 0,
            "nomePessoa": "",
            "cpf": "",
            "idEmailPessoal": 0,
            "emailPessoal": "",
            "idEmailFuncional": 0,
            "emailFuncional": "",
            "enderecoPessoal": {
                "idEndereco": 0,
                "logradouro": "",
                "numero": "",
                "complemento": "",
                "bairro": "",
                "idCidade": 0,
                "cidade": "",
                "idEstado": 0,
                "estado": "",
                "cep": "",
                "tipoEndereco": "RESIDENCIAL"
            },
            "enderecoFuncional": {
                "idEndereco": 0,
                "logradouro": "",
                "numero": "",
                "complemento": "",
                "bairro": "",
                "idCidade": 0,
                "cidade": "",
                "idEstado": 0,
                "estado": "",
                "cep": "",
                "tipoEndereco": "COMERCIAL"
            },
            "telefones": [
            ]
        };

        telefoneParaAdicionar: any = {
            dsContato: '',
            dsTipoContato: ''
        }
        periodoFuncaoParaAdicionar: any = {
            "idPeriodoFuncao": 0,
            "dataInicio": "",
            "dataFim": "",
            "idPessoaFuncao": 0,
            "portarias": ""
        }

        myDatePickerNomeacaoOptions: IMyDpOptions;
        myDatePickerPublicacaoOptions: IMyDpOptions;
        myDateRangePickerOptions: IMyDrpOptions;

        selectedDateRange: IMyDateRange;

        selectedText: string = '';
        border: string = 'none';

        placeholderTxt: string = 'Selecione o Período...';        

        order: string = 'pessoa.nomePessoa';
        reverse: boolean = false;

        codigoModulo: any = 0;
        analise: any = null;

        desabilitarImportacao = true;

        //Construtor da Página
        constructor(public contratosGestaoService: ContratosGestaoService,
            public rolResponsaveisService: RolresponsaveisService,
            public usuarioService: UsuarioService,
            public modalCtrl: ModalController,
            public navParams: NavParams,
            public contratoService: ContratoService,
            public gestaoPcaService: GestaoPcaService,
            public alertService: AlertService,
            private cdRef: ChangeDetectorRef,
            public menuService: MenuService) {
            super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

            this.analise = this.navParams.get('analise');

            if (this.isJurisdicionado) {
                this.codigoModulo = this.navParams.get('analise').idModuloPca;
            }

            //let date = new Date();
            this.myDatePickerNomeacaoOptions = {
                dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Hoje',
                firstDayOfWeek: 'su',
                disableWeekends: false,
                editableDateField: true,
                openSelectorOnInputClick: true,
                showClearDateBtn: false,
                openSelectorTopOfInput: true,
                showSelectorArrow: false
            };

            this.myDatePickerPublicacaoOptions = {
                dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Hoje',
                firstDayOfWeek: 'su',
                disableWeekends: false,
                editableDateField: true,
                openSelectorOnInputClick: true,
                showClearDateBtn: false,
                componentDisabled: true,
                openSelectorTopOfInput: true,
                showSelectorArrow: false
            };

            this.myDateRangePickerOptions = {
                dateFormat: 'dd/mm/yyyy',
                dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
                firstDayOfWeek: 'su',
                showApplyBtn: false,
                showClearDateRangeBtn: false,
                selectBeginDateTxt: 'Selecione a Data de Início',
                selectEndDateTxt: 'Selecione a Data de Fim',
                openSelectorOnInputClick: true,
                editableDateRangeField: false,
                width: '100%'
                //disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
            };

            this.usuario = this.usuarioService.obtemUsuario();
            this.isJurisdicionado = this.usuarioService.isJurisdicionado();
            this.isCGE = this.usuarioService.isCGE();
            this.PCAAtiva = this.gestaoPcaService.getPCA();
            //this.pessoaGrupoAtual.idPca = this.PCAAtiva.id;

            usuarioService.getUsuario().subscribe(broadcastVariable => {
                this.usuario = broadcastVariable.usr;
                this.isJurisdicionado = this.usuarioService.isJurisdicionado();
                this.isCGE = this.usuarioService.isCGE();
            });
            
            this.carregarRolReponsaveis();
            this.carregarTiposTelefones();
            this.carregarCargos();
            this.carregarTiposAtos();
            this.carregarEstados();
            this.carregarFuncoes();
            this.carregarContratosGestao();

            
            this.setModuloId(14);
        }

        onDataNascimentoChanged(event: IMyDateModel) {
            if (event.formatted !== '') {
              this.pessoaAtual.dataNascimento = new Date(event.jsdate).toLocaleDateString('pt-br');
            }
        }

        ngAfterViewChecked() {
            this.cdRef.detectChanges();
        }

        setOrder(value: string) {
            if (this.order === value) {
                this.reverse = !this.reverse;
            }

            this.order = value;
        }

        carregarContratosGestao(){
            this.loadingContratos = true;
            this.contratosGestaoService.obterContratos().subscribe(items => {
                this.listaContratos = items;
                this.loadingContratos = false;
            }, (err) => {
                console.log(err);
                this.listaContratos = [];
                this.loadingContratos = false;
            });
        }

        carregarRolReponsaveis() {
            this.desabilitarImportacao = true;
            this.loading = true;
            this.contratosGestaoService.getRolResponsaveis().subscribe(data => {
                this.rolDeResponsaveis = data;
                this.desabilitarImportacao = this.rolDeResponsaveis.length > 0;
                this.loading = false;
            },
            error => {
                console.log("erro: " + error);
                this.loading = false;
            });
        }

        importarDoAnoAnterior() {

            this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
                "Deseja importar os registros do ano anterior? Certifique-se de cadastrar todos os Contratos de Gestão antes de realizar a importação.", 
                callback => {            
                    if (callback) {
                        this.loading = true;
                        this.desabilitarImportacao = true;                    
                        this.contratosGestaoService.importarRolResponsaveis(this.codigoModulo).subscribe(data => {
                            this.alertService.mostraAlerta("", data.mensagem);
                            this.carregarRolReponsaveis();
                        }, error => {
                            console.log("erro: " + error.mensagem);
                            this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                            this.carregarRolReponsaveis();
                        });
                    }
                }
            );
          }

        carregarFuncoes() {
            this.contratosGestaoService.getGrupos().subscribe(data => {
                this.listaGrupos = data;
            },
                error => {
                    console.log("erro: " + error);
                });
        }

        cpf_mask(v) {
            v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
            return v;
        }

        carregarTiposTelefones() {
            this.rolResponsaveisService.buscarTiposTelefone().subscribe(data => {
                this.listaTiposTelefone = data;

                var index = this.listaTiposTelefone.indexOf('Fax');
                this.listaTiposTelefone.splice(index, 1);

            },
                error => {
                    console.log("erro: " + error);
                });
        }

        carregarCargos() {
            this.contratosGestaoService.getSubGrupos(this.pessoaGrupoAtual.idGrupo).subscribe(data => {
                this.listaCargos = data;
            },
                error => {
                    console.log("erro: " + error);
                });
        }

        carregarTiposAtos() {
            this.rolResponsaveisService.buscarTiposAtos().subscribe(data => {
                this.listaAtos = data;
            },
                error => {
                    console.log("erro: " + error);
                });
        }

        carregarEstados() {
            this.rolResponsaveisService.buscarEstados().subscribe(data => {
                this.listaEstados = data;
            },
                error => {
                    console.log("erro: " + error);
                });
        }

        redirecionarParaGestaoPCA() {
            console.log('entrei');
        }

        buscarPessoaPorCPF(cpf) {
            cpf = cpf.replace(/[^\w\s]/gi, '');

            this.cpfCarregado = false;
            this.rolResponsaveisService.buscarPessoaPorCPF(cpf).subscribe(data => {
                if (data != null &&
                    data.nomePessoa != "") {
                    this.pessoaAtual = data;
                    this.carregarCidadesDosEnderecosParaEdicao(this.pessoaAtual);
                }
                else {
                    this.limparCamposPessoa(false);
                }
                this.cpfPreenchido = this.cpfCarregado = true;
                this.funcaoSelecionada = false;
            },
                error => {
                    console.log("erro: " + error);
                    this.cpfPreenchido = this.cpfCarregado = true;
                });
        }

        // fileChange(event) {
        //     this.contratosGestaoService.xmlRolUpload(event, this.PCAAtiva.id).subscribe(data => this.rolDeResponsaveis = data.rolResponsavel, error => console.log("erro: " + error));
        // }

        apresentaModal(titulo: String, jsonObjeto: any) {
            let modal = this.modalCtrl.create(ModalDetalhesRolResponsaveisPage, { param1: titulo, param2: jsonObjeto });
            modal.onDidDismiss(retornoModal => {
                if (retornoModal) {
                }
            });
            modal.present();
        };

        toggleGroup(group) {
            if (this.isGroupShown(group)) {
                let index = this.shownGroup.indexOf(group);
                this.shownGroup.splice(index, 1);
            } else {
                this.shownGroup.push(group);
            }
        }
        isGroupShown(group) {
            return this.shownGroup.indexOf(group) != -1;
        };
        toggleGroupAtos(group) {
            if (this.isGroupShownAtos(group)) {
                let index = this.shownGroupAtos.indexOf(group);
                this.shownGroupAtos.splice(index, 1);
            } else {
                this.shownGroupAtos.push(group);
            }
        }
        isGroupShownAtos(group) {
            return this.shownGroupAtos.indexOf(group) != -1;
        };
        toggleGroupTelefones(group) {
            if (this.isGroupShownTelefones(group)) {
                let index = this.shownGroupTelefones.indexOf(group);
                this.shownGroupTelefones.splice(index, 1);
            } else {
                this.shownGroupTelefones.push(group);
            }
        }
        isGroupShownTelefones(group) {
            return this.shownGroupTelefones.indexOf(group) != -1;
        };

        adicionarResponsavel() {
            this.telaListagem = this.cpfPreenchido = false;
            this.telaCriacao = this.criacaoResponsavel = true;
            this.selectedContrato = [];
        }

        voltarParaListagem() {
            this.telaListagem = true;
            this.telaCriacao =
                this.criacaoResponsavel =
                this.edicaoResponsavel =
                this.cpfPreenchido =
                this.funcaoSelecionada =
                this.visualizacaoResponsavel = false;
            this.limparCampos();
            this.carregarRolReponsaveis();
        }

        excluirResponsavel(pessoaFuncao, dsFuncao) {
            this.loading = true;
            this.alertService.mostraModalConfirmacao("Excluir responsável",
                "Confirma a exclusão do responsável (" + pessoaFuncao.pessoa.nomePessoa
                + ") da função " + dsFuncao + " ?", retorno => {
                    if (retorno) {
                        this.contratosGestaoService.excluirResponsavel(pessoaFuncao.idPessoaGrupo).subscribe(data => {
                            this.alertService.mostraAlerta("", "Responsável excluído com sucesso!");
                            this.carregarRolReponsaveis();
                        },
                            error => {
                                this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir o responsável:" + error);
                                console.log("erro: " + error);
                                this.loading = false;
                            });
                    }
                });
        }

        editarResponsavel(pessoaFuncao) {
            this.loading = true;
            this.scrollToTop();
            this.pessoaGrupoAtual = pessoaFuncao;
            this.pessoaAtual = pessoaFuncao.pessoa;
            this.carregarCidadesDosEnderecosParaEdicao(pessoaFuncao.pessoa);
            this.telaListagem = false;
            this.telaCriacao = this.cpfPreenchido = this.edicaoResponsavel = this.funcaoSelecionada = true;
            this.loading = false;
            this.selectedContrato = pessoaFuncao.contrato;
        }

        visualizarResponsavel(pessoaFuncao) {
            this.loading = true;
            this.scrollToTop();
            this.pessoaGrupoAtual = pessoaFuncao;
            this.pessoaAtual = pessoaFuncao.pessoa;
            this.carregarCidadesDosEnderecosParaEdicao(pessoaFuncao.pessoa);
            this.telaListagem = false;
            this.telaCriacao = this.cpfPreenchido = this.visualizacaoResponsavel = this.funcaoSelecionada = true;
            this.loading = false;
            this.selectedContrato = pessoaFuncao.contrato;
        }

        scrollToTop() {
            this.content.scrollToTop();
        }

        carregarCidadesDosEnderecosParaEdicao(pessoa) {
            this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(data => {
                this.listaCidadesEnderecoPessoal = data;
                this.pessoaAtual.enderecoPessoal.idCidade = pessoa.enderecoPessoal.idCidade;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
                console.log("erro: " + error);
            });

            this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(data => {
                this.listaCidadesEnderecoFuncional = data;
                this.pessoaAtual.enderecoFuncional.idCidade = pessoa.enderecoFuncional.idCidade;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
                console.log("erro: " + error);
            });
        }

        onCEPAlteradoEnderecoFuncional() {
            if (this.cepValido(this.pessoaAtual.enderecoFuncional.cep)) {
                this.buscandoCEPFuncional = true;
                this.rolResponsaveisService.buscarEnderecoPorCEP(this.pessoaAtual.enderecoFuncional.cep).subscribe(data => {
                    if (data != undefined && !data.erro) {
                        this.pessoaAtual.enderecoFuncional.logradouro = data.logradouro;
                        this.pessoaAtual.enderecoFuncional.bairro = data.bairro;

                        let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
                        if (estadoTemp != null) {
                            this.pessoaAtual.enderecoFuncional.idEstado = estadoTemp.idEstado;
                            this.pessoaAtual.enderecoFuncional.estado = data.uf;
                        }

                        this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(dataCidades => {
                            this.listaCidadesEnderecoFuncional = dataCidades;

                            let cidadeTemp = this.listaCidadesEnderecoFuncional.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
                            if (cidadeTemp != null) {
                                this.pessoaAtual.enderecoFuncional.idCidade = cidadeTemp.idCidade;
                                this.pessoaAtual.enderecoFuncional.cidade = data.localidade;
                            }
                        }, error => {
                            console.log("erro: " + error);
                        });
                    }
                    else {
                        this.limparCamposEnderecoFuncional();
                    }
                    this.buscandoCEPFuncional = false;
                },
                    error => {
                        console.log("erro: " + error);
                        this.limparCamposEnderecoFuncional();
                        this.buscandoCEPFuncional = false;
                    });
            }
            else {
                this.limparCamposEnderecoFuncional();
            }
        }

        onCEPAlteradoEnderecoPessoal() {
            if (this.cepValido(this.pessoaAtual.enderecoPessoal.cep)) {
                this.buscandoCEPPessoal = true;
                this.rolResponsaveisService.buscarEnderecoPorCEP(this.pessoaAtual.enderecoPessoal.cep).subscribe(data => {
                    if (data != undefined && !data.erro) {
                        this.pessoaAtual.enderecoPessoal.logradouro = data.logradouro;
                        this.pessoaAtual.enderecoPessoal.bairro = data.bairro;

                        let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
                        if (estadoTemp != null) {
                            this.pessoaAtual.enderecoPessoal.idEstado = estadoTemp.idEstado;
                            this.pessoaAtual.enderecoPessoal.estado = data.uf;
                        }

                        this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(dataCidades => {
                            this.listaCidadesEnderecoPessoal = dataCidades;

                            let cidadeTemp = this.listaCidadesEnderecoPessoal.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
                            if (cidadeTemp != null) {
                                this.pessoaAtual.enderecoPessoal.idCidade = cidadeTemp.idCidade;
                                this.pessoaAtual.enderecoPessoal.cidade = data.localidade;
                            }
                        }, error => {
                            console.log("erro: " + error);
                        });
                    }
                    else {
                        this.limparCamposEnderecoPessoal();
                    }
                    this.buscandoCEPPessoal = false;
                },
                    error => {
                        console.log("erro: " + error);
                        this.limparCamposEnderecoPessoal();
                        this.buscandoCEPPessoal = false;
                    });
            }
            else {
                this.limparCamposEnderecoPessoal();
            }
        }

        cepValido(cep) {
            return cep.toString().replace('-', '').length == 8;
        }

        limparCamposEnderecoFuncional() {
            this.pessoaAtual.enderecoFuncional.logradouro
                = this.pessoaAtual.enderecoFuncional.bairro
                = this.pessoaAtual.enderecoFuncional.idEstado
                = this.pessoaAtual.enderecoFuncional.estado
                = this.pessoaAtual.enderecoFuncional.idCidade
                = this.pessoaAtual.enderecoFuncional.cidade = "";
        }

        limparCamposEnderecoPessoal() {
            this.pessoaAtual.enderecoPessoal.logradouro
                = this.pessoaAtual.enderecoPessoal.bairro
                = this.pessoaAtual.enderecoPessoal.idEstado
                = this.pessoaAtual.enderecoPessoal.estado
                = this.pessoaAtual.enderecoPessoal.idCidade
                = this.pessoaAtual.enderecoPessoal.cidade = "";
        }

        adicionarTelefone() {
            if (this.telefoneParaAdicionar.dsContato != '' &&
                this.telefoneParaAdicionar.dsTipoContato != '') {

                let valido = false;

                if ((this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 10) || (this.telefoneParaAdicionar.dsContato.replace(/[^\w\s]/gi, '').replace(' ', '').replace('_', '').length == 11)) {
                    valido = true;
                }


                if (valido) {
                    let telefoneNovo = {
                        "idContato": 0,
                        "dsContato": this.telefoneParaAdicionar.dsContato,
                        "dsTipoContato": this.telefoneParaAdicionar.dsTipoContato,
                        "idTipoContato": 0
                    };

                    let tipoContatoTemp = this.listaTiposTelefone.filter((tipoContato) => this.telefoneParaAdicionar.dsTipoContato == tipoContato.dsTipoContato)[0];

                    if (tipoContatoTemp != null) {
                        telefoneNovo.idTipoContato = tipoContatoTemp.idTipoContato;
                    }

                    if (this.pessoaAtual.telefones.findIndex(i => i.dsContato === telefoneNovo.dsContato) != -1) {
                        this.alertService.mostraAlerta("", "Telefone já adicionado!");
                    }
                    else {
                        this.pessoaAtual.telefones.push(telefoneNovo);
                        this.telefoneParaAdicionar.dsContato =
                            this.telefoneParaAdicionar.dsTipoContato = '';
                    }
                } else {
                    this.alertService.mostraAlerta("", "O Telefone é inválido.");
                }
            }
        }

        adicionarPeriodoFuncao() {
            if (this.periodoFuncaoParaAdicionar.dataInicio != '' &&
                this.periodoFuncaoParaAdicionar.dataFim != '') {
                let periodoFuncaoNovo = {
                    "idPeriodoFuncao": 0,
                    "dataInicio": this.periodoFuncaoParaAdicionar.dataInicio,
                    "dataFim": this.periodoFuncaoParaAdicionar.dataFim,
                    "idPessoaFuncao": 0,
                    "portarias": []
                };

                if (this.pessoaAtual.telefones.findIndex(i => i.dataInicio === periodoFuncaoNovo.dataInicio &&
                    i.dataFim === periodoFuncaoNovo.dataFim) != -1) {
                    this.alertService.mostraAlerta("", "Período já adicionado!");
                }
                else {
                    this.clearDateRange();
                    
                    this.pessoaGrupoAtual.listaPeriodoFuncao.push(periodoFuncaoNovo);
                    this.periodoFuncaoParaAdicionar.dataInicio =
                        this.periodoFuncaoParaAdicionar.dataFim = '';

                }
            }
        }

        adicionarPortaria(periodoFuncao) {
            let modal = this.modalCtrl.create(ModalPortariasPage, { 
                periodoFuncao: periodoFuncao, 
                jurisdicionado: this.isJurisdicionado, 
                analise: this.analise,
                isUmRegistro: true });
            modal.onDidDismiss(retornoModal => {

                if (retornoModal && retornoModal.salvar && this.isJurisdicionado) {

                    // this.removerPeriodoFuncao(periodoFuncao, false);

                    // retornoModal.periodoFuncao.portarias = retornoModal.periodoFuncao.portarias.filter(function (element) {
                    //     return element !== undefined;
                    // });

                    // this.pessoaGrupoAtual.listaPeriodoFuncao.push(retornoModal.periodoFuncao);

                    this.alertService.mostraAlerta("", "Ato de Nomeação salvo com sucesso.");

                }
            });
            modal.present();
        }

        removerTelefone(telefone) {
            let index = this.pessoaAtual.telefones.indexOf(telefone);
            this.pessoaAtual.telefones.splice(index, 1);
        }

        removerPeriodoFuncao(periodoFuncao, deletar = true) {
            let index = this.pessoaGrupoAtual.listaPeriodoFuncao.indexOf(periodoFuncao);
            this.pessoaGrupoAtual.listaPeriodoFuncao.splice(index, 1);

            if (periodoFuncao.idPeriodoFuncao != undefined && periodoFuncao.idPeriodoFuncao != 0 && deletar) {
                console.log("periodoFuncao.idPeriodoFuncao" + periodoFuncao.idPeriodoFuncao)
                this.periodosParaRemover.push(periodoFuncao);
            }
        }

        // onDataNascimentoChanged(event: IMyDateModel) {
        //     if (event.formatted !== '') {
        //       this.pessoaAtual.dataNascimento = new Date(event.jsdate).toLocaleDateString('pt-br');
        //     }
        //   }

        salvarResponsavel() {
            this.loading = true;

            if (this.formularioEhValido()) {                
                
                this.pessoaAtual.cpf = this.pessoaAtual.cpf.replace(/[^\w\s]/gi, '');
                this.pessoaGrupoAtual.pessoa = this.pessoaAtual;

                this.pessoaGrupoAtual.pessoa.enderecoPessoal.tipoEndereco = "RESIDENCIAL";
                this.pessoaGrupoAtual.pessoa.enderecoFuncional.tipoEndereco = "COMERCIAL";

                this.pessoaGrupoAtual.contrato = this.selectedContrato;

                if (this.periodosParaRemover && this.periodosParaRemover.length > 0) {
                    let contador = 1;                    
                    
                    this.periodosParaRemover.forEach(periodo => {                        
                        this.contratosGestaoService.deletarAtoNomeacao(periodo.idPeriodoFuncao).subscribe(
                            () => {
                                if (contador == this.periodosParaRemover.length) {                                    
                                    this.chamarEndPointSalvarResponsavel();
                                }
                                contador++;
                            },
                            (error) => {
                                this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir os Períodos de Efetiva Gestão: " + error.mensagem);
                                this.loading = false;
                            }
                        );
                    });
                } else {                    
                    this.chamarEndPointSalvarResponsavel();
                }
            }
        }

        private chamarEndPointSalvarResponsavel() {
            this.loading = true;
            this.contratosGestaoService.salvarResponsavel(this.pessoaGrupoAtual).subscribe(data => {
                this.alertService.mostraAlerta("", "Responsável (" + this.pessoaAtual.nomePessoa + ") salvo com sucesso !");
                this.voltarParaListagem();
            },
            error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar: " + error.mensagem);
                console.log(JSON.stringify(error));
                this.loading = false;
            });
        }

        formularioEhValido() {
            let ehValido = true;
            let textoValidacoesTitulo = "Favor informar os campos abaixo antes de salvar: <br><br>";
            let textoValidacoes = '';
            let constPularLinhaHTML = "<br>";
            // REGULAR EXPRESSION TO VALIDATE EMAIL FIELDS
            let emailRegularExpression = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!this.selectedContrato 
                || this.selectedContrato.id == 0 
                || this.selectedContrato.nmContrato == ''
                || this.selectedContrato.length == 0) {
                textoValidacoes += '- Contrato' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.nomePessoa == '') {
                textoValidacoes += '- Nome' + constPularLinhaHTML;
            }            
            if (this.isNullOrEmpty(this.pessoaAtual.emailFuncional) || !emailRegularExpression.test(this.pessoaAtual.emailFuncional)) {
                textoValidacoes += '- E-mail funcional' + constPularLinhaHTML;
            }
            if (this.isNullOrEmpty(this.pessoaAtual.emailPessoal) || !emailRegularExpression.test(this.pessoaAtual.emailPessoal)) {
                textoValidacoes += '- E-mail pessoal' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoFuncional.cep == '') {
                textoValidacoes += '- CEP (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoFuncional.logradouro == '') {
                textoValidacoes += '- Logradouro (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoFuncional.numero == '') {
                textoValidacoes += '- Número (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoFuncional.bairro == '') {
                textoValidacoes += '- Bairro (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoFuncional.idEstado == '') {
                textoValidacoes += '- UF (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.idCidade == '') {
                textoValidacoes += '- Cidade (Endereço funcional)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.cep == '') {
                textoValidacoes += '- CEP (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.logradouro == '') {
                textoValidacoes += '- Logradouro (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.numero == '') {
                textoValidacoes += '- Número (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.bairro == '') {
                textoValidacoes += '- Bairro (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.idEstado == '') {
                textoValidacoes += '- UF (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.enderecoPessoal.idCidade == '') {
                textoValidacoes += '- Cidade (Endereço pessoal)' + constPularLinhaHTML;
            }
            if (this.pessoaAtual.telefones.length == 0) {
                textoValidacoes += '- Telefone (Pelo menos 1 deve ser informado)' + constPularLinhaHTML;
            }
            if (this.pessoaGrupoAtual.idGrupo == '' ||
                this.pessoaGrupoAtual.idGrupo == 0) {
                textoValidacoes += '- Grupo' + constPularLinhaHTML;
            }
            if (this.pessoaGrupoAtual.subGrupo.idSubgrupo == '' ||
                this.pessoaGrupoAtual.subGrupo.idSubgrupo == 0) {
                textoValidacoes += '- SubGrupo Exercido' + constPularLinhaHTML;
            }            

            /*         if (this.pessoaFuncaoAtual.dsDescricaoCargo == '') {
                        textoValidacoes += '- Descrição do cargo' + constPularLinhaHTML;
                    } */
            if (this.pessoaGrupoAtual.listaPeriodoFuncao.length == 0) {
                textoValidacoes += '- Período de efetiva gestão (Pelo menos 1 deve ser informado)' + constPularLinhaHTML;
            }

            if (this.pessoaGrupoAtual.listaPeriodoFuncao != undefined && this.pessoaGrupoAtual.listaPeriodoFuncao != null && this.pessoaGrupoAtual.listaPeriodoFuncao.length > 0) {
                this.pessoaGrupoAtual.listaPeriodoFuncao.forEach(periodo => {

                    if (periodo.portarias == undefined || periodo.portarias == null || periodo.portarias.length == 0) {
                        textoValidacoes += '- Portaria (Pelo menos 1 deve ser informada) - Período de Efetiva Gestão: ' + periodo.dataInicio + ' a ' + periodo.dataFim + constPularLinhaHTML;
                    }
                });
            }


            if ((this.pessoaAtual.enderecoPessoal.logradouro == this.pessoaAtual.enderecoFuncional.logradouro) &&
                (this.pessoaAtual.enderecoPessoal.numero == this.pessoaAtual.enderecoFuncional.numero)) {
                textoValidacoes += '- O Endereço Funcional deve ser diferente do Endereço Pessoal' + constPularLinhaHTML;
            }
            /* 
                    if (this.pessoaFuncaoAtual.dsDescricaoCargo.length <= 30) {
                        textoValidacoes += '- A Descrição do Cargo deve ser maior do que 30 caracteres' + constPularLinhaHTML;
                    } */

            if (textoValidacoes != '') {
                ehValido = false;
                this.alertService.mostraAlerta("Campos obrigatórios", textoValidacoesTitulo + textoValidacoes);
            }

            return ehValido;
        }

        onEstadoEnderecoPessoalAlterado() {
            this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoPessoal.idEstado).subscribe(data => {
                this.listaCidadesEnderecoPessoal = data;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
                console.log("erro: " + error);
            });
        }

        onEstadoEnderecoFuncionalAlterado() {
            this.rolResponsaveisService.buscarCidadesPorEstado(this.pessoaAtual.enderecoFuncional.idEstado).subscribe(data => {
                this.listaCidadesEnderecoFuncional = data;
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
                console.log("erro: " + error);
            });
        }

        onCPFAlterado() {
            if (this.validarCPF(this.pessoaAtual.cpf)) {
                this.cpfInvalido = false;
                this.buscarPessoaPorCPF(this.pessoaAtual.cpf);
            }
            else {
                this.cpfPreenchido = false;
            }
        }

        onFuncaoAlterada() {
            this.funcaoSelecionada = this.pessoaGrupoAtual.idGrupo != undefined && this.pessoaGrupoAtual.idGrupo >= 0;
        }

        preencherCamposFuncao(pessoaFuncao) {
            this.pessoaGrupoAtual.idPessoaGrupo = pessoaFuncao.idPessoaGrupo;
            this.pessoaGrupoAtual.idGrupo = pessoaFuncao.idGrupo;
            //this.pessoaGrupoAtual.dsDescricaoCargo = pessoaFuncao.dsDescricaoCargo;
            this.pessoaGrupoAtual.subGrupo.idSubgrupo = pessoaFuncao.subGrupo.idSubgrupo;
            this.pessoaGrupoAtual.subGrupo.dsSubgrupo = pessoaFuncao.subGrupo.dsSubgrupo;
            this.pessoaGrupoAtual.listaPeriodoFuncao = pessoaFuncao.listaPeriodoFuncao;
            //this.pessoaFuncaoAtual.listaPortarias = pessoaFuncao.listaPortarias;
        }

        existeAlgumCampoFuncaoPreenchido() {
            return this.pessoaGrupoAtual.dsDescricaoCargo != '' ||
                this.pessoaGrupoAtual.subGrupo.idSubgrupo != '' ||
                this.pessoaGrupoAtual.subGrupo.dsSubgrupo != '' ||
                this.pessoaGrupoAtual.listaPeriodoFuncao.length > 0;
            //  ||
            // this.pessoaFuncaoAtual.listaPortarias.length > 0;
        }

        limparCampos() {
            this.pessoaGrupoAtual = {
                "idPessoaGrupo": 0,
                // "dsDescricaoCargo": "",
                // "idPca": this.PCAAtiva.idPca,
                "idGrupo": 0,
                "subGrupo": {
                    "idSubgrupo": "",
                    "dsSubgrupo": ""
                },
                "listaPeriodoFuncao": [
                    // ],
                    // "listaPortarias": [
                ]
            };

            this.periodosParaRemover = [];
            this.telefonesParaRemover = [];

            this.limparCamposPessoa();

            this.telefoneParaAdicionar = {
                dsContato: '',
                dsTipoContato: ''
            }
            this.limparCamposPeriodoFuncao();
            //this.limparCamposPortaria();

            this.cpfPreenchido =
                this.cpfInvalido = false;

            this.selectedContrato = [];
        }

        limparCamposPessoa(limparCpf = true) {
            this.pessoaAtual = {
                "idPessoa": 0,
                "nomePessoa": "",
                "cpf": limparCpf ? '' : this.pessoaAtual.cpf,
                "idEmailPessoal": 0,
                "emailPessoal": "",
                "idEmailFuncional": 0,
                "emailFuncional": "",
                "enderecoPessoal": {
                    "idEndereco": 0,
                    "logradouro": "",
                    "numero": "",
                    "complemento": "",
                    "bairro": "",
                    "idCidade": 0,
                    "cidade": "",
                    "idEstado": 0,
                    "estado": "",
                    "cep": "",
                    "tipoEndereco": "RESIDENCIAL"
                },
                "enderecoFuncional": {
                    "idEndereco": 0,
                    "logradouro": "",
                    "numero": "",
                    "complemento": "",
                    "bairro": "",
                    "idCidade": 0,
                    "cidade": "",
                    "idEstado": 0,
                    "estado": "",
                    "cep": "",
                    "tipoEndereco": "COMERCIAL"
                },
                "telefones": [
                ]
            };
        }

        limparCamposPeriodoFuncao() {
            this.periodoFuncaoParaAdicionar = {
                "idPeriodoFuncao": 0,
                "dataInicio": "",
                "dataFim": "",
                "idPessoaFuncao": 0,
                "portarias": []
            }
        }

        limparCamposParaNovaFuncao() {
            this.limparCamposPeriodoFuncao();
            //this.limparCamposPortaria();
            //this.pessoaGrupoAtual.dsDescricaoCargo = '';
            this.pessoaGrupoAtual.subGrupo.idSubgrupo = '';
            this.pessoaGrupoAtual.subGrupo.dsSubgrupo = '';
            this.pessoaGrupoAtual.listaPeriodoFuncao = [];
            //this.pessoaFuncaoAtual.listaPortarias = [];
            this.pessoaGrupoAtual.idPessoaGrupo = 0;
        }

        validarCPF(cpf) {
            let ehValido = true;

            cpf = cpf.replace(/[^\w\s]/gi, '');

            if (cpf == '') {
                this.cpfInvalido = false;
                return false;
            }

            if (cpf.length != 11) {
                this.cpfInvalido = false;
                return false;
            }

            // Elimina CPFs invalidos conhecidos
            if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
                cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
                cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
                this.cpfInvalido = true;
                return false;
            }

            // Valida 1o digito
            let add = 0;
            for (let i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9))) {
                this.cpfInvalido = true;
                return false;
            }

            // Valida 2o digito
            add = 0;
            for (let i = 0; i < 10; i++) {
                add += parseInt(cpf.charAt(i)) * (11 - i);
            }
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10))) {
                this.cpfInvalido = true;
                return false;
            }

            return ehValido;
        }

        onDateRangeChanged(event: IMyDateRangeModel) {

            if (event.formatted !== '') {

                this.border = '1px solid #CCC';

                this.periodoFuncaoParaAdicionar.dataInicio = new Date(event.beginJsDate).toLocaleDateString('pt-br');
                this.periodoFuncaoParaAdicionar.dataFim = new Date(event.endJsDate).toLocaleDateString('pt-br');

                let copy = this.getCopyOfNomeacaoOptions();

                copy.componentDisabled = false;
                copy.disableUntil = { year: event.beginJsDate.getFullYear(), month: event.beginJsDate.getMonth() + 1, day: event.beginJsDate.getDate() - 1 };
                copy.disableSince = { year: event.endJsDate.getFullYear(), month: event.endJsDate.getMonth() + 1, day: event.endJsDate.getDate() + 1 };

                this.myDatePickerNomeacaoOptions = copy;

            }
            else {
                this.selectedText = '';
                this.border = 'none';
            }
        }

        clearDateRange(): void {
            this.selectedDateRange = null;
        }

        getCopyOfPublicacaoOptions(): IMyDpOptions {
            return JSON.parse(JSON.stringify(this.myDatePickerPublicacaoOptions));
        }

        getCopyOfNomeacaoOptions(): IMyDpOptions {
            return JSON.parse(JSON.stringify(this.myDatePickerNomeacaoOptions));
        }

        voltarParaContratosGestao() {
            this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
        }

        printData() {

            var doc = new jsPDF("l");
            var totalPagesExp = "{total_pages_count_string}";

            var pageContent = function (data) {
                // HEADER
                doc.setFontSize(20);
                doc.setTextColor(40);
                doc.setFontStyle('normal');

                doc.text("Contratos de Gestão - Rol de Responsáveis", data.settings.margin.left + 15, 22);

                // FOOTER
                var str = "Page " + data.pageCount;
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp;
                }
                doc.setFontSize(10);
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
            };

            var columns = [
                { title: "Nome", dataKey: "nome" },
                { title: "CPF", dataKey: "cpf" },
                { title: "Categoria", dataKey: "categ" },
                { title: "Cargo", dataKey: "cargo" },
                { title: "Início Efetiva Gestão", dataKey: "inicio" },
                { title: "Fim Efetiva Gestão", dataKey: "fim" }
            ];

            let rows = [];

            this.rolDeResponsaveis.forEach(rol => {
                rol.listaPessoaFuncao.forEach(pessoa => {
                    pessoa.listaPeriodoFuncao.forEach(periodoFuncao => {
                        var item = {
                            "nome": pessoa.pessoa.nomePessoa,
                            "cpf": this.cpf_mask(pessoa.pessoa.cpf),
                            "categ": rol.dsFuncao,
                            "cargo": pessoa.cargo.nomeCargo,
                            "inicio": periodoFuncao.dataInicio,
                            "fim": periodoFuncao.dataFim
                        };

                        rows.push(item);
                    });
                });
            });

            doc.autoTable(columns, rows, {
                theme: 'grid',
                addPageContent: pageContent,
                margin: { top: 30 },
                styles: {
                    overflow: 'linebreak',
                    columnWidth: 'auto',
                    fontSize: 8
                },
                columnStyles: {
                    desc: { columnWidth: 'auto' }
                }
            });

            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            doc.save('cg_rol_responsaveis.pdf');
        }

        modalEvidencias(item: any) {

            let titulo = "Evidências";

            let modal = this.modalCtrl.create(ModalArquivosPage,
                {
                    titulo: titulo,
                    IdProcesso: item.idPessoaGrupo,
                    idModuloPCA: this.codigoModulo,
                    tipoAnalise: 0,
                    jurisdicionado: this.isJurisdicionado,
                    isCGE: this.isCGE,
                    origemArquivo: "Processo: " + item.idPessoaGrupo,
                    tipoEntidadeExercicio: 0,
                    pFlSefaz: 0,
                    tipodocumento: 0,
                    analise: this.analise
                });

            modal.present();

        }

        finalizar() {

            if (this.rolDeResponsaveis) {
                this.contratosGestaoService.finalizarResponsavel(this.rolDeResponsaveis).subscribe(data => {
                    this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                    this.voltarParaContratosGestao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
                });
            }
        }

        private isNullOrEmpty(value: any): boolean {
            return !value || (value && value === '') || (value && value.toString().trim() === '');
        }
    }



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/rol-responsaveis/rol-responsaveis.ts